import { render } from "./AdminHome.vue?vue&type=template&id=7f1b2cd4"
import script from "./AdminHome.vue?vue&type=script&lang=ts"
export * from "./AdminHome.vue?vue&type=script&lang=ts"
script.render = render

export default script